<template>
  <div
    ref="stars"
    :class="['star-rating', { 'star-rating--interactive': isInteractive }]"
    v-on="isInteractive ? { mouseleave: () => setInteractiveRating(-1) } : {}"
  >
    <IconStar
      v-for="n in starTotal"
      :key="n"
      :isInactive="n > displayedRating"
      :variant="variant"
      :hasBorderOnly="isInteractive && n > displayedRating"
      :hasAlert="isInteractive && hasAlert && displayedRating < 0"
      v-data-test-id="'star-rating-star'"
      v-on="
        isInteractive
          ? { click: () => setSavedRating(n), mouseenter: () => setInteractiveRating(n) }
          : {}
      "
    />
    <slot name="below"></slot>
  </div>
</template>

<script>
import Vue from 'vue'
import IconStar from '@/components/_shared/IconStar.vue'
import propsFiveStars from '@/components/_shared/Form/FiveStarsRating/props-five-stars'

export { VARIANTS } from '@/components/_shared/IconStar.vue'

export default {
  name: 'FiveStarsRating',
  components: { IconStar },

  props: { ...propsFiveStars },

  data() {
    return {
      starTotal: 5,
      interactiveRating: -1,
    }
  },

  computed: {
    displayedRating() {
      return this.interactiveRating >= 0 ? this.interactiveRating : this.value
    },
  },

  mounted() {
    if (this.value < 0 && !this.isInteractive) {
      Vue.util.warn('Missing required prop: "value"', this)
    }
  },

  methods: {
    getFieldEl() {
      return this.$refs.stars
    },

    focus() {
      this.getFieldEl()?.focus()
    },

    setInteractiveRating(value) {
      if (!this.isDisabled) this.interactiveRating = value
    },

    setSavedRating(value) {
      this.$emit('update:value', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.star-rating {
  display: inline-block;
  font-size: 0;
  white-space: nowrap;

  &--interactive {
    cursor: pointer;
  }
}
</style>
